import styled from 'styled-components';
import { FormControl } from '@famly/mf_input_form-control';
export const StyledFormControl = styled(FormControl) `
    justify-content: flex-end;
`;
